import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';
import type { OpportunityRoom } from './useGetOffer';

export type OpportunityRelatedExtraGuestSurcharge = {
  age_range__c?: string | null;
  bedding_type__c?: string | null;
  collected_by__c?: string | null;
  extra_guest_type__c?: string | null;
  id: string;
  inclusions__c?: string | null;
  name?: string | null;
  opportunity__c?: string | null;
  other_extra_bedding_type__c?: string | null;
};

export type OpportunityRelatedDeal = OpportunityRoom & {
  blackout_dates__c?: string | null;
  bundled_experiences__c?: string | null;
  channel_fare_type__c?: string | null;
  child_age_permitted__c?: string | null;
  number_of_bundled_experience__c?: number | string | null;
  offer_discount__c?: number | string | null;
  travel_end_date__c?: string | null;
  travel_start_date__c?: string | null;
};

export type OpportunityRelatedInclusion = {
  id: string;
  deal_offer__c?: string | null;
  description__c?: string | null;
  name?: string | null;
  rrp__c?: number | string | null;
  total_value__c?: number | string | null;
  type__c?: string | null;
};

export type OpportunityRelatedRecords = {
  deals?: Array<OpportunityRelatedDeal>;
  extra_guest_surcharges?: Array<OpportunityRelatedExtraGuestSurcharge>;
  inclusions?: Array<OpportunityRelatedInclusion>;
  rooms?: Array<OpportunityRoom>;
};

export function useGetOpportunityRelated(
  opportunityId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: offerQueryKeys.opportunityRelated(opportunityId),
    queryFn: async () => {
      if (!opportunityId) {
        throw new Error('opportunityId is required');
      }

      const response = await OffersService.getOpportunityRelated(opportunityId);
      return response.result as OpportunityRelatedRecords;
    },
    enabled: enabled && !!opportunityId,
  });
}
